
import { useBannerAds } from "@/hooks/useBannerAds";
import BannerItem from "./BannerItem";
import { useState, useEffect } from "react";

export default function BannerAdsDisplay() {
  const { banners, loading, error } = useBannerAds();
  const [currentAdIndex, setCurrentAdIndex] = useState(0);

  // Rotate ads every page refresh
  useEffect(() => {
    if (banners.length > 0) {
      const randomIndex = Math.floor(Math.random() * banners.length);
      setCurrentAdIndex(randomIndex);
    }
  }, [banners.length]);

  if (loading) return null; // avoid layout shift
  if (error) return null; // don't display on error
  if (!banners.length) return null;

  const currentBanner = banners[currentAdIndex];

  return (
    <div className="w-full my-4 flex flex-row justify-center items-center">
      <BannerItem
        key={currentBanner.id}
        id={currentBanner.id}
        image_url={currentBanner.image_url}
        alt_text={currentBanner.alt_text}
        target_url={currentBanner.target_url}
      />
    </div>
  );
}
